<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      中山公园站<br>
站点介绍<br>
中山公园站位于南山大道与玉泉路交叉口，沿南山大道呈南北向布置。车站设置四个出入口，为地下两层岛式车站，地下一层为站厅层，地下二层为站台层。站厅及站台两端为设备区，中部为公共区，有效站台两侧设站台门，车站周边有中山公园建安大院、马家龙街心公园、南头城莲花广场等。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:25	23:21	12号线	4分钟	8分钟<br>
海上田园东	06:27	23:51	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:29	23:21	12号线	8分钟	8分钟<br>
海上田园东	06:29	23:51	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
玉泉路东侧、莲城花园、中山苑、麒麟小学麒麟中学、南山区税务局、马家龙街心公园<br><br>
B出入口:<br>
南山大道东侧、建安大院、南头派出所、南头城莲花广场<br><br>
C出入口:<br>
南山大道西侧、臻林天汇大厦、中山公园<br><br>
D出入口:<br>
南山大道西侧、中国石化加油站、天主教圣保禄堂<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 玉泉南山路口<br>
37、122、高峰专线138、M222、201、226、M343、高峰专线139、M298<br><br>
B出入口:<br>
公交站名： 中山公园东门<br>
21、22、37、201、226、324高峰专线62、高峰专线138、M176、M343、M349、M425、M475、M492、M506<br><br>
C出入口:<br>
公交站名： 中山公园东门<br>
22、高峰专线62、M349、M492、M506、21、37、201、324、M176、M343、M425、M506<br><br>
D出入口:<br>
公交站名： 南山公安分局②<br>
201、M176、高峰专线62<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>